import { Divider } from "@chakra-ui/react";
import CustomStepper from "components/ui/custom-stepper/CustomStepper";
import StepperProvider from "components/ui/custom-stepper/CustomStepperContext";
import HeaderBarInternal from "components/ui/HeaderBarInternal";
import { wrapperDialogDefaultProps } from "features/emails/config";
import { PropsWithChildren } from "react";
import { useLocation } from "react-router-dom";

type LayoutAgendaSteps = PropsWithChildren<{
  //contentGroup: any;
  activeStepIndex?: number;
  isEditing?: boolean;
}>;

export default function LayoutAgendaSteps({
  children,
  isEditing,
  contentGroup,
  activeStepIndex = 0,
}: LayoutAgendaSteps) {
  const location = useLocation();

  return (
    <StepperProvider
      steps={["Identificação", "Notas e resumo", "Conferir dados"]}
      activeStepIndex={activeStepIndex}
    >
      <HeaderBarInternal
        //title={contentGroup ? `Novo disparo de ${CONTENT_GROUP_TYPE_NAMES[contentGroup.type]} - ${contentGroup.name}`: 'Novo disparo'}
        title={isEditing ? "Editar disparo" : "Novo disparo"}
        backTo={`/disparos-de-agenda${location.search}`}
        dialogProps={wrapperDialogDefaultProps}
      >
        <CustomStepper />
      </HeaderBarInternal>

      <Divider />

      {children}
    </StepperProvider>
  );
}
